/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_InformationInputs */

const en_read_along_information = /** @type {(inputs: Read_Along_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information`)
};

const es_read_along_information = /** @type {(inputs: Read_Along_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información`)
};

/**
* | output |
* | --- |
* | "Information" |
*
* @param {Read_Along_InformationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_information = /** @type {((inputs?: Read_Along_InformationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_InformationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_information(inputs)
	return en_read_along_information(inputs)
});